import gql from 'graphql-tag'

export default gql`fragment signatureData on User {
  _id
  signature {
    _id
    default
    image {
      url
    }
  }
  signatures {
    _id
    default
    image {
      url
    }
  }
}`



// WEBPACK FOOTER //
// ./src/App/Pages/Settings/Signature/signatureDataFragment.js